import { ReactNode } from 'react';
import { CardSection, ScrollArea } from '@mantine/core';

type TouringCardSectionPropsType = {
  children: ReactNode;
};

export const TouringCardSection: React.FC<TouringCardSectionPropsType> = ({
  children,
}) => {
  return (
    <CardSection>
      <ScrollArea>{children}</ScrollArea>
    </CardSection>
  );
};
